type TestWithOptionalDates = {
  started?: string | null;
  codeExpiration?: string | null;
};

/** Format minutes as dd:hh:mm for CTT timeout fields; null/blank means no timeout. */
export function formatDdHhMmFromMinutes(minutes: number | null | undefined) {
  if (minutes == null || minutes <= 0) {
    return "";
  }
  const safeMinutes = Math.max(0, minutes);
  const days = Math.floor(safeMinutes / 1440).toString().padStart(2, "0");
  const hours = Math.floor((safeMinutes % 1440) / 60).toString().padStart(2, "0");
  const mins = (safeMinutes % 60).toString().padStart(2, "0");
  return `${days}:${hours}:${mins}`;
}

/** Parse dd:hh:mm (or partial segments) to total minutes; blank/invalid → null (no timeout). */
export function parseDdHhMmToMinutes(value: string | null | undefined) {
  const trimmed = (value ?? "").trim();
  if (!trimmed) return null;

  const parts = trimmed.split(":").map((part) => Number(part));
  const days = Number.isFinite(parts[0]) ? parts[0] : 0;
  const hours = Number.isFinite(parts[1]) ? parts[1] : 0;
  const mins = Number.isFinite(parts[2]) ? parts[2] : 0;
  const total = days * 1440 + hours * 60 + mins;
  if (!Number.isFinite(total) || total <= 0) {
    return null;
  }
  return total;
}

/** Convert stored code-timeout minutes to hours for summary list display; null means blank. */
export function codeTimeoutMinutesToHours(minutes: number | null | undefined) {
  if (minutes == null || minutes <= 0) {
    return "";
  }
  return minutes / 60;
}

/** Code expiration is only meaningful before the test has started. */
export function visibleCodeExpiration(test: TestWithOptionalDates | null | undefined) {
  if (!test?.codeExpiration || test.started) {
    return null;
  }
  return test.codeExpiration;
}
